<template>
  <div class="copertina-container">
    <div class="copyright">
      <div class="text">In esclusiva su</div>
      <div class="audible-logo">
        <img style="padding-left: 12px; width: 150px;" src="/images/audible_logo_grey.svg" alt="">
      </div>
    </div>
    <div class="title">
      <div class="line-1">
        <img src="/images/copertina/line_1.png" alt="">
      </div>
      <div class="line-2">
        <img class="base" src="/images/copertina/line_2_base.png" alt="">
        <img class="overlay" src="/images/copertina/line_2_overlay.png" alt="">
      </div>
      <div class="line-3">
        <div v-if="$tvaMq != 'mobile'" style="display: flex; flex-direction: row;">
          <div>Una produzione</div>
          <div>
            <img style="padding-left: 4px; padding-right: 4px;" src="/images/audible_original.svg" alt="">
          </div>
          <div>in collaborazione con</div>
          <div>
            <img style="padding-left: 4px; padding-right: 4px;" src="/images/gli_ascoltabili.svg" alt="">
          </div>
        </div>
        <div v-else style="display: flex; flex-direction: column; align-items: center;">
          <div class="row-1" style="display: flex; direction: row; align-items: center;">
            <div style="font-size: 12px;">Una produzione</div>
            <div style="padding-left: 8px; padding-bottom: 4px; width: 100px;">
              <img style="width: 100%;" src="/images/audible_original.svg" alt="">
            </div>
          </div>
          <div class="row-2" style="display: flex; direction: row; align-items: center;">
            <div style="font-size: 12px;">in collaborazione con</div>
            <div style="padding-left: 8px; padding-bottom: 4px; width: 100px;">
              <img style="width: 100%;" src="/images/gli_ascoltabili.svg" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="esclusiva-audible">
      <img src="/images/copertina/banding_light.png" alt="">
    </div>
    <img class="visual" src="/images/copertina/visual.svg" alt="">
  </div>
</template>
<script>
import gsap from "gsap";
import { TimelineMax } from 'gsap'
export default {
  props: ["content"],
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
.copertina-container{
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  padding-top: 40px;
  padding-bottom: 150px;
  align-items: center;
  .copyright{
    display: flex;
    flex-direction: row;
    align-items: center;
    .text{
      @include mdf-copyright;
    }
  }
  .title{
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-top: -80px;
    .line-1{
      position: relative;
      display: block;
      width: 500px;
      img{
        width: 100%;
      }
    }
    .line-2{
      position: relative;
      display: block;
      width: 500px;
      padding-top: 12px;
      img{
        width: 100%;
      }
      .overlay{
        position: absolute;
        left: 0px;
      }
    }
    .line-3{
      position: relative;
      display: block;
      color: #FFFFFF;
      font-family: Montserrat;
      font-size: 21px;
      font-weight: 500;
      letter-spacing: 2px;
      line-height: 28px;
      padding-top: 24px;
    }
  }
  .esclusiva-audible{
    position: absolute;
    right: 0px;
    width: 200px;
    bottom: -15px;
    z-index: 10;
    img{
      width: 100%;
    }
  }
  .visual{
    position: absolute;
    width: 100%;
    bottom: -10px;
  }
}

/* Smartphones (portrait and landscape) ----------- */
@media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
  .copertina-container{
    .copyright{
      position: relative;
      .text{
        font-size: 14px;
      }
      .audible-logo{
        img{
          width: 100%;
        }
      }
    }
    .title{
      margin-top: 0px;
      .line-1{
        width: 80%;
      }
      .line-2{
        width: 80%;
      }
      .line-3{
      }
    }
    .visual{
      width: 800px;
    }
    .esclusiva-audible{
      width: 120px;
    }
  }
}
</style>
